import { createFileRoute } from "@tanstack/react-router";
import { ListChecksIcon } from "lucide-react";

import { PoliciesSection } from "../components/regulation/PoliciesSection";
import { PolicyUploadAction } from "../components/regulation/PolicyUploadAction";
import { StartFromTemplateLink } from "../components/regulation/templates/StartFromTemplateLink";
import { RegulationSectionPage } from "../components/regulation/RegulationSectionPage";

/**
 * Procedures are the same records as policies — same governance, findings,
 * versions, controls and text — filtered to the other shelf. One component
 * renders both, so a procedure page is never a worse policy page.
 */
function LibraryProceduresRoute() {
  return (
    <RegulationSectionPage
      title="Procedures"
      description="Operating procedures that put your policies into practice."
      emptyIcon={ListChecksIcon}
      emptyTitle="No procedures yet"
      emptyBody="Procedures describe how policy is carried out day to day. Move a document here from its Overview tab, or ask eve to."
      actions={
        <div className="flex flex-wrap items-center gap-2">
          <StartFromTemplateLink />
          <PolicyUploadAction documentKind="procedure" />
        </div>
      }
    >
      <PoliciesSection documentKind="procedure" />
    </RegulationSectionPage>
  );
}

export const Route = createFileRoute("/$org/compliance/procedures")({
  component: LibraryProceduresRoute,
});
